import React from 'react';
import cancelEvent from '../../../../../services/mini/cancelEvent';

class BillingFormHolder extends React.Component {

    clickInsideForm = (e) => {
        cancelEvent(e);
    }

    render() {
        const { isVisible, header, form, canBeClosed, isOpened, onClick, onClose, openedFormHeight } = this.props;
        const style = {
            minHeight: `${openedFormHeight}px`,
            maxHeight: `${openedFormHeight}px`,
            height: `${openedFormHeight}px`
        };
        if (!isVisible) return <React.Fragment />;

        return (
            <div
                className={`billing-form-holder ${isOpened && 'opened'} ${!canBeClosed && 'one'}`}
                onClick={onClick}>
                <div className="billing-form-holder__header"
                    onClick={canBeClosed ? onClose : undefined}>
                    {header}
                </div>
                <div className="billing-form-holder__body" style={isOpened ? style : {}}
                    onClick={this.clickInsideForm}>
                    {form}
                </div>
            </div>
        );
    }
}

export default BillingFormHolder;
